import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import GeneratedCodeDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.GeneratedCodeDto;
import RecoveryCodesDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.RecoveryCodesDto;
import VerificationCodeDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.VerificationCodeDto;
import LoginStage = Cloud.RavenDB.Core.Dto.TwoFactorAuth.LoginStage;
import LoginStageResponseDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.LoginStageResponseDto;
import LoginWith2faDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.LoginWith2faDto;
import LoginWithRecoveryCodeDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.LoginWithRecoveryCodeDto;
import TwoFactorConfigurationDto = Cloud.RavenDB.Core.Dto.TwoFactorAuth.TwoFactorConfigurationDto;
import ProfileConfigurationDto = Cloud.RavenDB.Core.Dto.Profile.ProfileConfigurationDto;
import { downloadBlobAsFile } from "@commonClient/src/utils/fileUtils";

export default class AuthenticationService extends AbstractService {
    generateCode = async (): Promise<GeneratedCodeDto> => {
        const codes = await this.query<GeneratedCodeDto>(ApiRoutes.twoFactorAuthentication.generateCode());
        return codes.data;
    };

    generateRecoveryCodes = async (): Promise<RecoveryCodesDto> => {
        const codes = await this.post<RecoveryCodesDto>(ApiRoutes.twoFactorAuthentication.generateRecoveryCodes());

        return codes.data;
    };

    downloadRecoveryCodes = (fileName: string, content: string) => {
        const blob = new Blob([content], { type: "text/plain" });
        downloadBlobAsFile(fileName, blob);
    };

    disable2fa = async (): Promise<void> => {
        await this.post<void>(ApiRoutes.twoFactorAuthentication.disable2Fa());
    };

    verifyAppCode = async (dto: VerificationCodeDto): Promise<RecoveryCodesDto> => {
        const recoveryCodes = await this.post<VerificationCodeDto, RecoveryCodesDto>(
            ApiRoutes.twoFactorAuthentication.verifyAppCode(),
            dto
        );
        return recoveryCodes.data;
    };

    getConfiguration = async (): Promise<TwoFactorConfigurationDto> => {
        const configuration = await this.query<ProfileConfigurationDto>(ApiRoutes.profile.getConfiguration());

        return configuration.data.twoFactor;
    };

    checkLoginStage = async (): Promise<LoginStage> => {
        const stage = await this.query<LoginStageResponseDto>(ApiRoutes.twoFactorAuthentication.getLoginStage());
        return stage.data.stage;
    };

    loginWith2fa = async (dto: LoginWith2faDto): Promise<void> => {
        await this.post<LoginWith2faDto, void>(ApiRoutes.twoFactorAuthentication.loginWith2Fa(), dto);
    };

    loginWithRecoveryCode = async (dto: LoginWithRecoveryCodeDto): Promise<void> => {
        await this.post<LoginWithRecoveryCodeDto, void>(ApiRoutes.twoFactorAuthentication.loginWithRecoveryCode(), dto);
    };

    forgetBrowser = async (): Promise<void> => {
        await this.post<void>(ApiRoutes.twoFactorAuthentication.forgetBrowser());
    };
}
